import axios from "./axios";
import PlaceholderGif from '../static/images/Placeholder.gif';
import AppliedGif from '../static/images/Icon_640-01.gif'
import PreEnrollmentSurveyGif from '../static/images/Icon_640-04.gif'
import ApplicationFeePaymentGif from '../static/images/Icon_640-02.gif'
import ExaminationScheduleGif from '../static/images/Icon_640-03.gif'
import AcceptanceLetterGif from '../static/images/Icon_640-05.gif'
import EnrollmentStatusGif from '../static/images/Icon_640-06.gif'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../components/ApplicantStatus.css';

export async function ApplicantStatusAPI() {
    var statusURL = "checkstatus/";
    const toastId = toast.loading('Loading status'); 
    try {
        document.getElementById('btnLogOut').style.visibility = "visible";
        var response = await axios.get(statusURL,
            {
                headers: {
                    "Authorization": 'bearer ' + localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
            });
        document.getElementById('btnLogOut').style.visibility = "visible";
        var data = JSON.stringify(response.data);
        var statusMessage = JSON.parse(data).status;
        var ExamDate = JSON.parse(data).examDate;
        var StudOrientationDate = JSON.parse(data).studOrientationDate;
        var lastName = JSON.parse(data).lastName;
        var firstName = JSON.parse(data).firstName;
        if (firstName == null) {
            firstName = "Future"
        }
        if (lastName == null) {
            lastName = "Mapúan"
        }
        var onemcluser = JSON.parse(data).onemcluser;
        var onemclpass = JSON.parse(data).onemclpass;
        var bbluser = JSON.parse(data).bbluser;
        var bblpass = JSON.parse(data).bblpass;
        var meltDate = JSON.parse(data).meltDate;
        var meltRoom = JSON.parse(data).meltRoom;
        var formType = JSON.parse(data).formType;
        toast.update(toastId, {
            render: "",
            type: 'success',
            isLoading: false,
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        })
        document.getElementById('futureMapuan').style.visibility = "visible";
        document.getElementById('studentName').innerText = firstName + " " + lastName;
        // Content for the different Stages
        if (statusMessage == "New") {
            document.getElementById('StatusMessage').innerText = "Pre-enrollment Survey";
            document.getElementById('StatusImage').style.content = "URL(" + PreEnrollmentSurveyGif + ")";
            document.getElementById('stagePreEnrollmentSurvey').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Validated" || statusMessage == "Application Fee Payment") {
            document.getElementById('StatusMessage').innerText = "Application Fee Payment";
            document.getElementById('StatusImage').style.content = "URL(" + ApplicationFeePaymentGif + ")";
            document.getElementById('stageApplicationFeePayment').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Diagnostic/Entrance Exam") {
            document.getElementById('StatusMessage').innerText = "Examination Schedule";
            document.getElementById('StatusImage').style.content = "URL(" + ExaminationScheduleGif + ")";
            document.getElementById('stageExaminationSchedule').style.display = "block";
            if (ExamDate != null) {
                document.getElementById('examDate').innerText = ExamDate + " (YYYY-MM-DD)";
            } else {
                document.getElementById('examDate').innerText = "(TBA)";
            }
            document.getElementById('contactChannels').style.display = "block";

        } else if (statusMessage == "Acceptance Letter") {
            document.getElementById('StatusMessage').innerText = "Acceptance Letter";
            document.getElementById('StatusImage').style.content = "URL(" + AcceptanceLetterGif + ")";
            document.getElementById('stageAcceptanceLetter').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Completed") {
            document.getElementById('StatusMessage').innerText = "Enrollment Status";
            document.getElementById('StatusImage').style.content = "URL(" + EnrollmentStatusGif + ")";
            document.getElementById('stageEnrollmentStatus').style.display = "block";
            //if (StudOrientationDate != null) {
            //    document.getElementById('NSODateTime').innerText = StudOrientationDate + " (MM-DD-YYYY)";
            //} else {
            //    document.getElementById('NSODateTime').innerText = "(TBA)";
            //}
            //if (meltDate != null) {
            //    document.getElementById('MELTDateTime').innerText = meltDate + " (MM-DD-YYYY)";
            //} else {
            //    document.getElementById('MELTDateTime').innerText = "(TBA)";
            //}
            //if (meltRoom != null) {
            //    document.getElementById('MELTRoom').innerText = meltRoom;
            //} else {
            //    document.getElementById('MELTRoom').innerText = "(TBA)";
            //}
            //document.getElementById("accountCredentials").style.display = "block";
            //document.getElementById("accountCredentialsNotReady").style.display = "none";
            document.getElementById("oneMCLUsername").innerText = onemcluser;
            document.getElementById("oneMCLPassword").innerText = onemclpass;
            document.getElementById("BBLUsername").innerText = bbluser;
            document.getElementById("BBLPassword").innerText = bblpass;
            document.getElementById("accountCredentialsNotReady").style.display = "none";
            if (formType === 'College') {
                document.getElementById('programSHS').style.display = "none";
                document.getElementById('programCollege').style.display = "block";
            } else {
                document.getElementById('programCollege').style.display = "none";
                document.getElementById('programSHS').style.display = "block";
            }
            if (onemcluser == null && onemclpass == null && bbluser == null && bblpass == null) {
                document.getElementById("accountCredentials").style.display = "none";
                document.getElementById("accountCredentialsNotReady").style.display = "block";
            }
            if (onemcluser == null) {
                document.getElementById("oneMCLUsername").innerText = "---";
            }
            if (onemclpass == null) {
                document.getElementById("oneMCLPassword").innerText = "---";
            }
            if (bbluser == null) {
                document.getElementById("BBLUsername").innerText = "---";
            }
            if (bblpass == null) { 
                document.getElementById("BBLPassword").innerText = "---";
            }
        } else {
            document.getElementById('StatusMessage').innerText = "Could not find current stage!";
            document.getElementById('futureMapuan').style.display = "none";
            document.getElementById('contactChannels').style.display = "block";
        }
        /* Updated on October 29, 2025. Delete this code for cleanup on end of November
        if (statusMessage == "New") {
            document.getElementById('StatusMessage').innerText = "Applied";
            document.getElementById('StatusImage').style.content = "URL(" + AppliedGif + ")";
            document.getElementById('stageApplied').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Pre-Enrollment Survey") {
            document.getElementById('StatusMessage').innerText = "Pre-enrollment Survey";
            document.getElementById('StatusImage').style.content = "URL(" + PreEnrollmentSurveyGif + ")";
            document.getElementById('stagePreEnrollmentSurvey').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Validated" || statusMessage == "Application Fee Payment") {
            document.getElementById('StatusMessage').innerText = "Application Fee Payment";
            document.getElementById('StatusImage').style.content = "URL(" + ApplicationFeePaymentGif + ")";
            document.getElementById('stageApplicationFeePayment').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Diagnostic/Entrance Exam") {
            document.getElementById('StatusMessage').innerText = "Examination Schedule";
            document.getElementById('StatusImage').style.content = "URL(" + ExaminationScheduleGif + ")";
            document.getElementById('stageExaminationSchedule').style.display = "block";
            if (ExamDate != null) {
                document.getElementById('examDate').innerText = ExamDate + " (YYYY-MM-DD)";
            } else {
                document.getElementById('examDate').innerText = "(TBA)";
            }
            document.getElementById('contactChannels').style.display = "block";

        } else if (statusMessage == "Acceptance Letter" || statusMessage == "Enrollment Requirements" || statusMessage == "Course Program") {
            document.getElementById('StatusMessage').innerText = "Acceptance Letter";
            document.getElementById('StatusImage').style.content = "URL(" + AcceptanceLetterGif + ")";
            document.getElementById('stageAcceptanceLetter').style.display = "block";
            document.getElementById('contactChannels').style.display = "block";
        } else if (statusMessage == "Tuition Fee Payment" || statusMessage == "Completed") {
            document.getElementById('StatusMessage').innerText = "Enrollment Status";
            document.getElementById('StatusImage').style.content = "URL(" + EnrollmentStatusGif + ")";
            document.getElementById('stageEnrollmentStatus').style.display = "block";
            //if (StudOrientationDate != null) {
            //    document.getElementById('NSODateTime').innerText = StudOrientationDate + " (MM-DD-YYYY)";
            //} else {
            //    document.getElementById('NSODateTime').innerText = "(TBA)";
            //}
            //if (meltDate != null) {
            //    document.getElementById('MELTDateTime').innerText = meltDate + " (MM-DD-YYYY)";
            //} else {
            //    document.getElementById('MELTDateTime').innerText = "(TBA)";
            //}
            //if (meltRoom != null) {
            //    document.getElementById('MELTRoom').innerText = meltRoom;
            //} else {
            //    document.getElementById('MELTRoom').innerText = "(TBA)";
            //}
            //document.getElementById("accountCredentials").style.display = "block";
            //document.getElementById("accountCredentialsNotReady").style.display = "none";
            document.getElementById("oneMCLUsername").innerText = onemcluser;
            document.getElementById("oneMCLPassword").innerText = onemclpass;
            document.getElementById("BBLUsername").innerText = bbluser;
            document.getElementById("BBLPassword").innerText = bblpass;
            document.getElementById("accountCredentialsNotReady").style.display = "none";
            if (formType === 'College') {
                document.getElementById('programSHS').style.display = "none";
                document.getElementById('programCollege').style.display = "block";
            } else {
                document.getElementById('programCollege').style.display = "none";
                document.getElementById('programSHS').style.display = "block";
            }
            if (onemcluser == null && onemclpass == null && bbluser == null && bblpass == null) {
                document.getElementById("accountCredentials").style.display = "none";
                document.getElementById("accountCredentialsNotReady").style.display = "block";
            }
            if (onemcluser == null) {
                document.getElementById("oneMCLUsername").innerText = "---";
            }
            if (onemclpass == null) {
                document.getElementById("oneMCLPassword").innerText = "---";
            }
            if (bbluser == null) {
                document.getElementById("BBLUsername").innerText = "---";
            }
            if (bblpass == null) { 
                document.getElementById("BBLPassword").innerText = "---";
            }
        } else {
            document.getElementById('StatusMessage').innerText = "Could not find current stage!";
            document.getElementById('futureMapuan').style.display = "none";
            document.getElementById('contactChannels').style.display = "block";
        }*/
    } catch (err)
    {
        toast.update(toastId, {
            render: 'Error: Could not find current stage.',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        })  
        document.getElementById('StatusMessage').innerText = "Could not find current stage";
        document.getElementById('futureMapuan').style.display = "none";
        document.getElementById('stageTimeout').style.display = "block";
        document.getElementById('contactChannels').style.display = "block";
    }
}
export default ApplicantStatusAPI;
